<!-- <h1>Enter Mobile Number With Country Code</h1>
{{addbalance}}
<mat-form-field appearance="fill" style="width: 100% !important;">
    <mat-label>Input</mat-label>
    <input matInput type="number" [(ngModel)]="mobileNumber">
  </mat-form-field>
  <div class="example-button-row">
    <button class= "subButton" mat-button color="primary" (click)="submit()">SUBMIT</button>
  </div> -->
<div>
  <div *ngIf="this.queryParam.lang === 'EN'" class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Mobile Number verification</h4>
  </div>
  <div *ngIf="this.queryParam.lang === 'SW'" class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Mobilnummer verifiering</h4>
  </div>
  <div *ngIf="queryParam.lang == 'SG'" class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Mobile Number verification</h4>
  </div>


  <div class="modal-body">
    <form>
      <div class="mb-3">
        <label *ngIf="this.queryParam.lang === 'EN'" for="dateOfBirth">{{this.enter}}<span style="color: brown;">{{addbalance}}</span></label>
        <label *ngIf="this.queryParam.lang === 'SW'" for="dateOfBirth">Ange mobilnummer :<span style="color: brown;">{{addbalance}}</span></label>
        <label *ngIf="this.queryParam.lang === 'SG'" for="dateOfBirth">Enter Mobile Number :<span style="color: brown;">{{addbalance}}</span></label>
        <div *ngIf="this.queryParam.lang === 'EN'" class="input-group">
          <input type="text" id="dateOfBirth" class="form-control" placeholder="mobile number" name="dp" [(ngModel)]="mobileNumber">
        </div>
        <div *ngIf="this.queryParam.lang === 'SW'" class="input-group">
          <input type="text" id="dateOfBirth" class="form-control" placeholder="Mobilnummer" name="dp" [(ngModel)]="mobileNumber">
        </div>
        <div *ngIf="this.queryParam.lang === 'SG'" class="input-group">
          <input type="text" id="dateOfBirth" class="form-control" placeholder="mobile number" name="dp" [(ngModel)]="mobileNumber">
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="this.queryParam.lang === 'EN'" class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submitActel()">SUBMIT</button>
  </div>
  <div *ngIf="this.queryParam.lang === 'SW'" class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submitActel()">SKICKA IN</button>
  </div>
  <div *ngIf="this.queryParam.lang == 'SG'" class="modal-footer">
    <button  type="button" class="btn btn-primary" (click)="submit()" >SUBMIT</button>
  </div>
</div>

<!-- for message cloud -->

<!-- New modal -->
<!-- <div *ngIf="queryParam.lang == 'SG'" class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Mobile Number verification</h4>
</div>
<div *ngIf="queryParam.lang == 'SG'" class="modal-body">
  <form>
    <div class="mb-3">
      <label for="dateOfBirth">Enter Mobile Number :<span style="color: brown;">{{addbalance}}</span></label>
      <div class="input-group">
        <input type="text" id="dateOfBirth" class="form-control" placeholder="mobile number" name="dp" [(ngModel)]="mobileNumber">
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button *ngIf="this.queryParam.lang == 'SG'" type="button" class="btn btn-primary" (click)="submit()" >SUBMIT</button>
</div>   -->






